// @flow
import * as React from 'react'
import styled from 'styled-components'

type Props = {
  dataCy?: string,
  title: string,
  subtitle: string,
  icon: string,
  onClick: () => void,
}

const ButtonContainer = styled.div`
  transform-style: preserve-3d;
  transition: transform 0.3s ease;
  width: 270px;
  &:hover {
    transform: translate3d(0px, -4px, 0px) scale3d(1, 1, 1) rotateX(0deg)
      rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
  }
`

const StyledButtonBlock = styled.div`
  align-items: center;
  align-self: center;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #d2d6dc;
  cursor: pointer;
  display: flex;
  flex: 0 auto;
  height: 12rem;
  justify-content: center;
  text-align: center;
  width: 12rem;

  &:hover {
    border: 2px solid #0059ff57;
  }
`

const ButtonTitle = styled.div`
  color: #041433;
  display: block;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin: 10px auto 0;
  text-align: center;
  text-decoration: none;
  width: 12rem;
`

const ButtonSubtitle = styled.div`
  color: rgb(123, 124, 139);
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 20px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  text-align: center;
  width: 12rem;
`

function ButtonBlock({
  dataCy,
  title,
  subtitle,
  icon,
  onClick,
}: Props): React.Node {
  return (
    <ButtonContainer data-cy={dataCy}>
      <StyledButtonBlock onClick={onClick}>
        <img alt="feature-icon" src={icon} width={73} />
      </StyledButtonBlock>
      <ButtonTitle>{title}</ButtonTitle>
      <ButtonSubtitle>{subtitle}</ButtonSubtitle>
    </ButtonContainer>
  )
}

export default ButtonBlock
